import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleButton } from "./toggleButton";
import { EditIcon } from "./editIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function TaskSection({
  title,
  children,
  edit,
  displayOnlyUser,
  setDisplayOnlyUser,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.section}>
      <div className={styles.heading}>
        <h1 className={styles.title}>{title}</h1>
        {edit && (
          <div className={styles.iconBox} onClick={edit}>
            <EditIcon className={styles.icon} />
          </div>
        )}
        <div className={styles.displayToggle}>
          {t("projectPage.synthesisPage.tasks.me")}
          <ToggleButton
            isActive={displayOnlyUser}
            setIsActive={setDisplayOnlyUser}
          />
          {t("projectPage.synthesisPage.tasks.everyone")}
        </div>
      </div>
      <div className={styles.main}>{children}</div>
    </div>
  );
}

export { TaskSection };
